{
  "id": "33cfr83",
  "title": "Navigation Rules, 33 CFR Part 83 (United States Coast Guard)",
  "edition": "2026-01-01",
  "retrieved": "2026-09-19",
  "url": "https://www.ecfr.gov/current/title-33/chapter-I/subchapter-E/part-83",
  "license": "US Government Work, gemeinfrei (17 U.S.C. 105)",
  "sections": {
    "83.01": {
      "rule": 1,
      "heading": "Application (Rule 1).",
      "paragraphs": [
        {
          "id": "a",
          "text": "(a) These Rules apply to all vessels upon the inland waters of the United States, and to vessels of the United States on the Canadian waters of the Great Lakes to the extent that there is no conflict with Canadian law."
        },
        {
          "id": "b",
          "text": "(b)(i) These Rules constitute special rules made by an appropriate authority within the meaning of Rule 1(b) of the International Regulations for Preventing Collisions at Sea, 1972, including annexes currently in force for the United States (“International Regulations”)."
        },
        {
          "id": "b(ii)",
          "text": "(ii) All vessels complying with the construction and equipment requirements of the International Regulations are considered to be in compliance with these Rules."
        },
        {
          "id": "c",
          "text": "(c) Nothing in these Rules shall interfere with the operation of any special rules made by the Secretary of the Navy with respect to additional station or signal lights and shapes or whistle signals for ships of war and vessels proceeding under convoy, or by the Secretary with respect to additional station or signal lights and shapes for fishing vessels engaged in fishing as a fleet. These additional station or signal lights and shapes or whistle signals shall, so far as possible, be such that they cannot be mistaken for any light, shape, or signal authorized elsewhere under these Rules. Notice of such special rules shall be published in the Federal Register and, after the effective date specified in such notice, they shall have effect as if they were a part of these Rules."
        },
        {
          "id": "d",
          "text": "(d) Traffic separation schemes may be established for the purpose of these Rules. Vessel traffic service regulations may be in effect in certain areas."
        },
        {
          "id": "e",
          "text": "(e) Whenever the Secretary determines that a vessel or class of vessels of special construction or purpose cannot comply fully with the provisions of any of these Rules with respect to the number, position, range, or arc of visibility of lights or shapes, as well as to the disposition and characteristics of sound-signaling appliances, the vessel shall comply with such other provisions in regard to the number, position, range, or arc of visibility of lights or shapes, as well as to the disposition and characteristics of sound-signaling appliances, as the Secretary shall have determined to be the closest possible compliance with these Rules. The Secretary may issue a certificate of alternative compliance for a vessel or class of vessels specifying the closest possible compliance with these Rules. The Secretary of the Navy shall make these determinations and issue certificates of alternative compliance for vessels of the Navy."
        },
        {
          "id": "f",
          "text": "(f) The Secretary may accept a certificate of alternative compliance issued by a contracting party to the International Regulations if it determines that the alternative compliance standards of the contracting party are substantially the same as those of the United States."
        },
        {
          "id": "g",
          "text": "(g) The operator of each self-propelled vessel 12 meters or more in length shall carry, on board and maintain for ready reference, a copy of these Rules."
        }
      ]
    },
    "83.02": {
      "rule": 2,
      "heading": "Responsibility (Rule 2).",
      "paragraphs": [
        {
          "id": "a",
          "text": "(a) Nothing in these Rules shall exonerate any vessel, or the owner, master, or crew thereof, from the consequences of any neglect to comply with these Rules or of the neglect of any precaution which may be required by the ordinary practice of seamen, or by the special circumstances of the case."
        },
        {
          "id": "b",
          "text": "(b) In construing and complying with these Rules due regard shall be had to all dangers of navigation and collision and to any special circumstances, including the limitations of the vessels involved, which may make a departure from these Rules necessary to avoid immediate danger."
        }
      ]
    },
    "83.03": {
      "rule": 3,
      "heading": "General definitions (Rule 3).",
      "paragraphs": [
        {
          "id": "intro",
          "text": "For the purpose of these Rules and Subchapter E, except where the context otherwise requires:"
        },
        {
          "id": "a",
          "text": "(a) The word vessel includes every description of water craft, including non-displacement craft, WIG craft and seaplanes, used or capable of being used as a means of transportation on water."
        },
        {
          "id": "b",
          "text": "(b) The term power-driven vessel means any vessel propelled by machinery."
        },
        {
          "id": "c",
          "text": "(c) The term sailing vessel means any vessel under sail provided that propelling machinery, if fitted, is not being used."
        },
        {
          "id": "d",
          "text": "(d) The term vessel engaged in fishing means any vessel fishing with nets, lines, trawls, or other fishing apparatus which restricts maneuverability, but does not include a vessel fishing with trolling lines or other fishing apparatus which do not restrict maneuverability."
        },
        {
          "id": "e",
          "text": "(e) The word seaplane includes any aircraft designed to maneuver on the water."
        },
        {
          "id": "f",
          "text": "(f) The term vessel not under command means a vessel which, through some exceptional circumstance, is unable to maneuver as required by these Rules and is therefore unable to keep out of the way of another vessel."
        },
        {
          "id": "g",
          "text": "(g) The term vessel restricted in her ability to maneuver means a vessel which, from the nature of her work, is restricted in her ability to maneuver as required by these Rules and is therefore unable to keep out of the way of another vessel. The term vessels restricted in their ability to maneuver include, but are not limited to:"
        },
        {
          "id": "g(i)",
          "text": "(i) A vessel engaged in laying, servicing, or picking up a navigation mark, submarine cable, or pipeline;"
        },
        {
          "id": "g(ii)",
          "text": "(ii) a vessel engaged in dredging, surveying, or underwater operations;"
        },
        {
          "id": "g(iii)",
          "text": "(iii) a vessel engaged in replenishment or transferring persons, provisions, or cargo while underway;"
        },
        {
          "id": "g(iv)",
          "text": "(iv) a vessel engaged in the launching or recovery of aircraft;"
        },
        {
          "id": "g(v)",
          "text": "(v) a vessel engaged in mine clearance operations;"
        },
        {
          "id": "g(vi)",
          "text": "(vi) a vessel engaged in a towing operation such as severely restricts the towing vessel and her tow in their ability to deviate from their course."
        },
        {
          "id": "h",
          "text": "(h) [Reserved]"
        },
        {
          "id": "h(i)",
          "text": "(i) The word underway means that a vessel is not at anchor, or made fast to the shore, or aground."
        },
        {
          "id": "j",
          "text": "(j) The words length and breadth of a vessel mean her length overall and greatest breadth."
        },
        {
          "id": "k",
          "text": "(k) Vessels shall be deemed to be in sight of one another only when one can be observed visually from the other."
        },
        {
          "id": "l",
          "text": "(l) The term restricted visibility means any condition in which visibility is restricted by fog, mist, falling snow, heavy rainstorms, sandstorms, or any other similar causes."
        },
        {
          "id": "m",
          "text": "(m) The term Wing-In-Ground (WIG) craft means a multimodal craft which, in its main operational mode, flies in close proximity to the surface by utilizing surface-effect action."
        },
        {
          "id": "n",
          "text": "(n) Western Rivers means the Mississippi River, its tributaries, South Pass, and Southwest Pass, to the navigational demarcation lines dividing the high seas from harbors, rivers, and other inland waters of the United States, and the Port Allen-Morgan City Alternate Route, and that part of the Atchafalaya River above its junction with the Port Allen-Morgan City Alternate Route including the Old River and the Red River."
        },
        {
          "id": "o",
          "text": "(o) Great Lakes means the Great Lakes and their connecting and tributary waters including the Calumet River as far as the Thomas J. O'Brien Lock and Controlling Works (between mile 326 and 327), the Chicago River as far as the east side of the Ashland Avenue Bridge (between mile 321 and 322), and the Saint Lawrence River as far east as the lower exit of Saint Lambert Lock."
        },
        {
          "id": "p",
          "text": "(p) Secretary means the Secretary of the Department in which the Coast Guard is operating."
        },
        {
          "id": "q",
          "text": "(q) Inland Waters means the navigable waters of the United States shoreward of the navigational demarcation lines dividing the high seas from harbors, rivers, and other inland waters of the United States and the waters of the Great Lakes on the United States side of the International Boundary."
        },
        {
          "id": "r",
          "text": "(r) Inland Rules or Rules means these Inland Navigational Rules and the annexes thereto, which govern the conduct of vessels and specify the lights, shapes, and sound signals that apply on inland waters."
        },
        {
          "id": "s",
          "text": "(s) International Regulations means the International Regulations for Preventing Collisions at Sea, 1972, including annexes currently in force for the United States."
        }
      ]
    },
    "83.04": {
      "rule": 4,
      "heading": "Application (Rule 4).",
      "paragraphs": [
        {
          "id": "intro",
          "text": "Rules 4 through 10 (§§ 83.04 through 83.10) apply in any condition of visibility."
        }
      ]
    },
    "83.05": {
      "rule": 5,
      "heading": "Look-out (Rule 5).",
      "paragraphs": [
        {
          "id": "intro",
          "text": "Every vessel shall at all times maintain a proper look-out by sight and hearing as well as by all available means appropriate in the prevailing circumstances and conditions so as to make a full appraisal of the situation and of the risk of collision."
        }
      ]
    },
    "83.06": {
      "rule": 6,
      "heading": "Safe speed (Rule 6).",
      "paragraphs": [
        {
          "id": "intro",
          "text": "Every vessel shall at all times proceed at a safe speed so that she can take proper and effective action to avoid collision and be stopped within a distance appropriate to the prevailing circumstances and conditions. In determining a safe speed the following factors shall be among those taken into account:"
        },
        {
          "id": "a",
          "text": "(a) By all vessels:"
        },
        {
          "id": "a(i)",
          "text": "(i) The state of visibility;"
        },
        {
          "id": "a(ii)",
          "text": "(ii) The traffic density including concentration of fishing vessels or any other vessels;"
        },
        {
          "id": "a(iii)",
          "text": "(iii) The maneuverability of the vessel with special reference to stopping distance and turning ability in the prevailing conditions;"
        },
        {
          "id": "a(iv)",
          "text": "(iv) At night, the presence of background light such as from shore lights or from back scatter of her own lights;"
        },
        {
          "id": "a(v)",
          "text": "(v) The state of wind, sea, and current, and the proximity of navigational hazards;"
        },
        {
          "id": "a(vi)",
          "text": "(vi) The draft in relation to the available depth of water."
        },
        {
          "id": "b",
          "text": "(b) Additionally, by vessels with operational radar:"
        },
        {
          "id": "b(i)",
          "text": "(i) The characteristics, efficiency and limitations of the radar equipment;"
        },
        {
          "id": "b(ii)",
          "text": "(ii) Any constraints imposed by the radar range scale in use;"
        },
        {
          "id": "b(iii)",
          "text": "(iii) The effect on radar detection of the sea state, weather, and other sources of interference;"
        },
        {
          "id": "b(iv)",
          "text": "(iv) The possibility that small vessels, ice and other floating objects may not be detected by radar at an adequate range;"
        },
        {
          "id": "b(v)",
          "text": "(v) The number, location, and movement of vessels detected by radar;"
        },
        {
          "id": "b(vi)",
          "text": "(vi) The more exact assessment of the visibility that may be possible when radar is used to determine the range of vessels or other objects in the vicinity."
        }
      ]
    },
    "83.07": {
      "rule": 7,
      "heading": "Risk of collision (Rule 7).",
      "paragraphs": [
        {
          "id": "a",
          "text": "(a) Every vessel shall use all available means appropriate to the prevailing circumstances and conditions to determine if risk of collision exists. If there is any doubt such risk shall be deemed to exist."
        },
        {
          "id": "b",
          "text": "(b) Proper use shall be made of radar equipment if fitted and operational, including long-range scanning to obtain early warning of risk of collision and radar plotting or equivalent systematic observation of detected objects."
        },
        {
          "id": "c",
          "text": "(c) Assumptions shall not be made on the basis of scanty information, especially scanty radar information."
        },
        {
          "id": "d",
          "text": "(d) In determining if risk of collision exists the following considerations shall be among those taken into account:"
        },
        {
          "id": "d(i)",
          "text": "(i) Such risk shall be deemed to exist if the compass bearing of an approaching vessel does not appreciably change."
        },
        {
          "id": "d(ii)",
          "text": "(ii) Such risk may sometimes exist even when an appreciable bearing change is evident, particularly when approaching a very large vessel or a tow or when approaching a vessel at close range."
        }
      ]
    },
    "83.08": {
      "rule": 8,
      "heading": "Action to avoid collision (Rule 8).",
      "paragraphs": [
        {
          "id": "a",
          "text": "(a) Any action taken to avoid collision shall be taken in accordance with the Rules of this subpart (Rules 4-19) (§§ 83.04 through 83.19) and shall, if the circumstances of the case admit, be positive, made in ample time and with due regard to the observance of good seamanship."
        },
        {
          "id": "b",
          "text": "(b) Any alteration of course and/or speed to avoid collision shall, if the circumstances of the case admit, be large enough to be readily apparent to another vessel observing visually or by radar; a succession of small alterations of course and/or speed should be avoided."
        },
        {
          "id": "c",
          "text": "(c) If there is sufficient sea room, alteration of course alone may be the most effective action to avoid a close-quarters situation provided that it is made in good time, is substantial and does not result in another close-quarters situation."
        },
        {
          "id": "d",
          "text": "(d) Action taken to avoid collision with another vessel shall be such as to result in passing at a safe distance. The effectiveness of the action shall be carefully checked until the other vessel is finally past and clear."
        },
        {
          "id": "e",
          "text": "(e) If necessary to avoid collision or allow more time to assess the situation, a vessel shall slacken her speed or take all way off by stopping or reversing her means of propulsion."
        },
        {
          "id": "f",
          "text": "(f)(i) A vessel which, by any of these Rules, is required not to impede the passage or safe passage of another vessel shall, when required by the circumstances of the case, take early action to allow sufficient sea room for the safe passage of the other vessel."
        },
        {
          "id": "f(ii)",
          "text": "(ii) A vessel required not to impede the passage or safe passage of another vessel is not relieved of this obligation if approaching the other vessel so as to involve risk of collision and shall, when taking action, have full regard to the action which may be required by the Rules of Subpart B (Rules 4-19)."
        },
        {
          "id": "f(iii)",
          "text": "(iii) A vessel the passage of which is not to be impeded remains fully obliged to comply with the Rules of Subpart B (Rules 4-19) when the two vessels are approaching one another so as to involve risk of collision."
        }
      ]
    },
    "83.09": {
      "rule": 9,
      "heading": "Narrow channels (Rule 9).",
      "paragraphs": [
        {
          "id": "a",
          "text": "(a)(i) A vessel proceeding along the course of a narrow channel or fairway shall keep as near to the outer limit of the channel or fairway which lies on her starboard side as is safe and practicable."
        },
        {
          "id": "a(ii)",
          "text": "(ii) Notwithstanding paragraph (a)(i) of this Rule and Rule 14(a) (§ 83.14(a)), a power-driven vessel operating in narrow channels or fairways on the Great Lakes, Western Rivers, or waters specified by the Secretary, and proceeding downbound with a following current shall have the right-of-way over an upbound vessel, shall propose the manner and place of passage, and shall initiate the maneuvering signals prescribed by Rule 34(a)(i) (§ 83.34(a)(i)), as appropriate. The vessel proceeding upbound against the current shall hold as necessary to permit safe passing."
        },
        {
          "id": "b",
          "text": "(b) A vessel of less than 20 meters in length or a sailing vessel shall not impede the passage of a vessel that can safely navigate only within a narrow channel or fairway."
        },
        {
          "id": "c",
          "text": "(c) A vessel engaged in fishing shall not impede the passage of any other vessel navigating within a narrow channel or fairway."
        },
        {
          "id": "d",
          "text": "(d) A vessel must not cross a narrow channel or fairway if such crossing impedes the passage of a vessel which can safely navigate only within such channel or fairway. The latter vessel must use the signal prescribed in Rule 34(d) (§ 83.34(d)) if in doubt as to the intention of the crossing vessel."
        },
        {
          "id": "e",
          "text": "(e)(i) In a narrow channel or fairway when overtaking, the power-driven vessel intending to overtake another power-driven vessel shall indicate her intention by sounding the appropriate signal prescribed in Rule 34(c) (§ 83.34(c)) and take steps to permit safe passing. The power-driven vessel being overtaken, if in agreement, shall sound the same signal and may, if specifically agreed to, take steps to permit safe passing. If in doubt she shall sound the signal prescribed in Rule 34(d) (§ 83.34(d))."
        },
        {
          "id": "e(ii)",
          "text": "(ii) This Rule does not relieve the overtaking vessel of her obligation under Rule 13 (§ 83.13)."
        },
        {
          "id": "f",
          "text": "(f) A vessel nearing a bend or an area of a narrow channel or fairway where other vessels may be obscured by an intervening obstruction shall navigate with particular alertness and caution and shall sound the appropriate signal prescribed in Rule 34(e) (§ 83.34(e))."
        },
        {
          "id": "g",
          "text": "(g) Any vessel shall, if the circumstances of the case admit, avoid anchoring in a narrow channel."
        }
      ]
    },
    "83.10": {
      "rule": 10,
      "heading": "Traffic separation schemes (Rule 10).",
      "paragraphs": [
        {
          "id": "a",
          "text": "(a) This Rule applies to traffic separation schemes and does not relieve any vessel of her obligation under any other Rule in subchapter E."
        },
        {
          "id": "b",
          "text": "(b) A vessel using a traffic separation scheme shall:"
        },
        {
          "id": "b(i)",
          "text": "(i) Proceed in the appropriate traffic lane in the general direction of traffic flow for that lane;"
        },
        {
          "id": "b(ii)",
          "text": "(ii) So far as practicable keep clear of a traffic separation line or separation zone;"
        },
        {
          "id": "b(iii)",
          "text": "(iii) Normally join or leave a traffic lane at the termination of the lane, but when joining or leaving from either side shall do so at as small an angle to the general direction of traffic flow as practicable."
        },
        {
          "id": "c",
          "text": "(c) A vessel shall, so far as practicable, avoid crossing traffic lanes but if obliged to do so shall cross on a heading as nearly as practicable at right angles to the general direction of traffic flow."
        },
        {
          "id": "d",
          "text": "(d)(i) A vessel shall not use an inshore traffic zone when she can safely use the appropriate traffic lane within the adjacent traffic separation scheme. However, vessels of less than 20 meters in length, sailing vessels, and vessels engaged in fishing may use the inshore traffic zone."
        },
        {
          "id": "d(ii)",
          "text": "(ii) Notwithstanding paragraph (d)(i) of this Rule, a vessel may use an inshore traffic zone when en route to or from a port, offshore installation or structure, pilot station, or any other place situated within the inshore traffic zone, or to avoid immediate danger."
        },
        {
          "id": "e",
          "text": "(e) A vessel other than a crossing vessel or a vessel joining or leaving a lane shall not normally enter a separation zone or cross a separation line except:"
        },
        {
          "id": "e(i)",
          "text": "(i) In cases of emergency to avoid immediate danger;"
        },
        {
          "id": "e(ii)",
          "text": "(ii) To engage in fishing within a separation zone."
        },
        {
          "id": "f",
          "text": "(f) A vessel navigating in areas near the terminations of traffic separation schemes shall do so with particular caution."
        },
        {
          "id": "g",
          "text": "(g) A vessel shall so far as practicable avoid anchoring in a traffic separation scheme or in areas near its terminations."
        },
        {
          "id": "h",
          "text": "(h) A vessel not using a traffic separation scheme shall avoid it by as wide a margin as is practicable."
        },
        {
          "id": "h(i)",
          "text": "(i) A vessel engaged in fishing shall not impede the passage of any vessel following a traffic lane."
        },
        {
          "id": "j",
          "text": "(j) A vessel of less than 20 meters in length or a sailing vessel shall not impede the safe passage of a power-driven vessel following a traffic lane."
        },
        {
          "id": "k",
          "text": "(k) A vessel restricted in her ability to maneuver when engaged in an operation for the maintenance of safety of navigation in a traffic separation scheme is exempted from complying with this Rule to the extent necessary to carry out the operation."
        },
        {
          "id": "l",
          "text": "(l) A vessel restricted in her ability to maneuver when engaged in an operation for the laying, servicing, or picking up of a submarine cable, within a traffic separation scheme, is exempted from complying with this Rule to the extent necessary to carry out the operation."
        }
      ]
    },
    "83.11": {
      "rule": 11,
      "heading": "Application (Rule 11).",
      "paragraphs": [
        {
          "id": "intro",
          "text": "Rules 11 through 18 (§§ 83.11 through 83.18) apply to vessels in sight of one another."
        }
      ]
    },
    "83.12": {
      "rule": 12,
      "heading": "Sailing vessels (Rule 12).",
      "paragraphs": [
        {
          "id": "a",
          "text": "(a) When two sailing vessels are approaching one another, so as to involve risk of collision, one of them shall keep out of the way of the other as follows:"
        },
        {
          "id": "a(i)",
          "text": "(i) When each has the wind on a different side, the vessel which has the wind on the port side shall keep out of the way of the other."
        },
        {
          "id": "a(ii)",
          "text": "(ii) When both have the wind on the same side, the vessel which is to windward shall keep out of the way of the vessel which is to leeward."
        },
        {
          "id": "a(iii)",
          "text": "(iii) If a vessel with the wind on the port side sees a vessel to windward and cannot determine with certainty whether the other vessel has the wind on the port or on the starboard side, she shall keep out of the way of the other."
        },
        {
          "id": "b",
          "text": "(b) For the purpose of this Rule, the windward side shall be deemed to be the side opposite to that on which the mainsail is carried or, in the case of a square-rigged vessel, the side opposite to that on which the largest fore-and-aft sail is carried."
        }
      ]
    },
    "83.13": {
      "rule": 13,
      "heading": "Overtaking (Rule 13).",
      "paragraphs": [
        {
          "id": "a",
          "text": "(a) Notwithstanding anything contained in Rules 4 through 18 (§§ 83.04 through 83.18), any vessel overtaking any other shall keep out of the way of the vessel being overtaken."
        },
        {
          "id": "b",
          "text": "(b) A vessel shall be deemed to be overtaking when coming up with another vessel from a direction more than 22.5 degrees abaft her beam; that is, in such a position with reference to the vessel she is overtaking, that at night she would be able to see only the sternlight of that vessel but neither of her sidelights."
        },
        {
          "id": "c",
          "text": "(c) When a vessel is in any doubt as to whether she is overtaking another, she shall assume that this is the case and act accordingly."
        },
        {
          "id": "d",
          "text": "(d) Any subsequent alteration of the bearing between the two vessels shall not make the overtaking vessel a crossing vessel within the meaning of these Rules or relieve her of the duty of keeping clear of the overtaken vessel until she is finally past and clear."
        }
      ]
    },
    "83.14": {
      "rule": 14,
      "heading": "Head-on situation (Rule 14).",
      "paragraphs": [
        {
          "id": "a",
          "text": "(a) Unless otherwise agreed, when two power-driven vessels are meeting on reciprocal or nearly reciprocal courses so as to involve risk of collision each shall alter her course to starboard so that each shall pass on the port side of the other."
        },
        {
          "id": "b",
          "text": "(b) Such a situation shall be deemed to exist when a vessel sees the other ahead or nearly ahead and by night she could see the masthead lights of the other in a line or nearly in a line and/or both sidelights and by day she observes the corresponding aspect of the other vessel."
        },
        {
          "id": "c",
          "text": "(c) When a vessel is in any doubt as to whether such a situation exists she shall assume that it does exist and act accordingly."
        },
        {
          "id": "d",
          "text": "(d) Notwithstanding paragraph (a) of this Rule, a power-driven vessel operating on the Great Lakes, Western Rivers, or waters specified by the Secretary, and proceeding downbound with a following current shall have the right-of-way over an upbound vessel, shall propose the manner of passage, and shall initiate the maneuvering signals prescribed by Rule 34(a)(i) (§ 83.34(a)(i)), as appropriate."
        }
      ]
    },
    "83.15": {
      "rule": 15,
      "heading": "Crossing situation (Rule 15).",
      "paragraphs": [
        {
          "id": "a",
          "text": "(a) When two power-driven vessels are crossing so as to involve risk of collision, the vessel which has the other on her starboard side shall keep out of the way and shall, if the circumstances of the case admit, avoid crossing ahead of the other vessel."
        },
        {
          "id": "b",
          "text": "(b) Notwithstanding paragraph (a) of this Rule, on the Great Lakes, Western Rivers, or water specified by the Secretary, a power-driven vessel crossing a river shall keep out of the way of a power-driven vessel ascending or descending the river."
        }
      ]
    },
    "83.16": {
      "rule": 16,
      "heading": "Action by give-way vessel (Rule 16).",
      "paragraphs": [
        {
          "id": "intro",
          "text": "Every vessel which is directed to keep out of the way of another vessel shall, so far as possible, take early and substantial action to keep well clear."
        }
      ]
    },
    "83.17": {
      "rule": 17,
      "heading": "Action by stand-on vessel (Rule 17).",
      "paragraphs": [
        {
          "id": "a",
          "text": "(a)(i) Where one of two vessels is to keep out of the way, the other shall keep her course and speed."
        },
        {
          "id": "a(ii)",
          "text": "(ii) The latter vessel may, however, take action to avoid collision by her maneuver alone, as soon as it becomes apparent to her that the vessel required to keep out of the way is not taking appropriate action in compliance with these Rules."
        },
        {
          "id": "b",
          "text": "(b) When, from any cause, the vessel required to keep her course and speed finds herself so close that collision cannot be avoided by the action of the give-way vessel alone, she shall take such action as will best aid to avoid collision."
        },
        {
          "id": "c",
          "text": "(c) A power-driven vessel which takes action in a crossing situation in accordance with paragraph (a)(ii) of this Rule to avoid collision with another power-driven vessel shall, if the circumstances of the case admit, not alter course to port for a vessel on her own port side."
        },
        {
          "id": "d",
          "text": "(d) This Rule does not relieve the give-way vessel of her obligation to keep out of the way."
        }
      ]
    },
    "83.18": {
      "rule": 18,
      "heading": "Responsibilities between vessels (Rule 18).",
      "paragraphs": [
        {
          "id": "intro",
          "text": "Except where Rules 9, 10, and 13 (§§ 83.09, 83.10, and 83.13) otherwise require:"
        },
        {
          "id": "a",
          "text": "(a) A power-driven vessel underway shall keep out of the way of:"
        },
        {
          "id": "a(i)",
          "text": "(i) A vessel not under command;"
        },
        {
          "id": "a(ii)",
          "text": "(ii) A vessel restricted in her ability to maneuver;"
        },
        {
          "id": "a(iii)",
          "text": "(iii) A vessel engaged in fishing;"
        },
        {
          "id": "a(iv)",
          "text": "(iv) A sailing vessel."
        },
        {
          "id": "b",
          "text": "(b) A sailing vessel underway shall keep out of the way of:"
        },
        {
          "id": "b(i)",
          "text": "(i) A vessel not under command;"
        },
        {
          "id": "b(ii)",
          "text": "(ii) A vessel restricted in her ability to maneuver; and"
        },
        {
          "id": "b(iii)",
          "text": "(iii) A vessel engaged in fishing."
        },
        {
          "id": "c",
          "text": "(c) A vessel engaged in fishing when underway shall, so far as possible, keep out of the way of:"
        },
        {
          "id": "c(i)",
          "text": "(i) A vessel not under command; and"
        },
        {
          "id": "c(ii)",
          "text": "(ii) A vessel restricted in her ability to maneuver."
        },
        {
          "id": "d",
          "text": "(d) [Reserved]"
        },
        {
          "id": "e",
          "text": "(e) A seaplane on the water shall, in general, keep well clear of all vessels and avoid impeding their navigation. In circumstances, however, where risk of collision exists, she shall comply with the Rules of this Subpart (Rules 4-19) (§§ 83.04 through 83.19); and"
        },
        {
          "id": "f",
          "text": "(f)(i) a WIG craft shall, when taking off, landing and in flight near the surface, keep well clear of all other vessels and avoid impeding their navigation; and"
        },
        {
          "id": "f(ii)",
          "text": "(ii) a WIG craft operating on the water surface shall comply with the Rules of this Subpart (Rules 4-19) (§§ 83.04 through 83.19) as a power-driven vessel."
        }
      ]
    },
    "83.19": {
      "rule": 19,
      "heading": "Conduct of vessels in restricted visibility (Rule 19).",
      "paragraphs": [
        {
          "id": "a",
          "text": "(a) This Rule applies to vessels not in sight of one another when navigating in or near an area of restricted visibility."
        },
        {
          "id": "b",
          "text": "(b) Every vessel shall proceed at a safe speed adapted to the prevailing circumstances and conditions of restricted visibility. A power-driven vessel shall have her engines ready for immediate maneuver."
        },
        {
          "id": "c",
          "text": "(c) Every vessel shall have due regard to the prevailing circumstances and conditions of restricted visibility when complying with Rules 4 through 10 (§§ 83.04 through 83.10)."
        },
        {
          "id": "d",
          "text": "(d) A vessel which detects by radar alone the presence of another vessel shall determine if a close-quarters situation is developing and/or risk of collision exists. If so, she shall take avoiding action in ample time, provided that when such action consists of an alteration of course, so far as possible the following shall be avoided:"
        },
        {
          "id": "d(i)",
          "text": "(i) An alteration of course to port for a vessel forward of the beam, other than for a vessel being overtaken;"
        },
        {
          "id": "d(ii)",
          "text": "(ii) An alteration of course toward a vessel abeam or abaft the beam."
        },
        {
          "id": "e",
          "text": "(e) Except where it has been determined that a risk of collision does not exist, every vessel which hears apparently forward of her beam the fog signal of another vessel, or which cannot avoid a close-quarters situation with another vessel forward of her beam, shall reduce her speed to the minimum at which she can be kept on course. She shall if necessary take all her way off and, in any event, navigate with extreme caution until danger of collision is over."
        }
      ]
    },
    "83.20": {
      "rule": 20,
      "heading": "Application (Rule 20).",
      "paragraphs": [
        {
          "id": "a",
          "text": "(a) Rules in this subpart (Rules 20-31) (§§ 83.20 through 83.31) shall be complied with in all weathers."
        },
        {
          "id": "b",
          "text": "(b) The Rules concerning lights (§§ 83.20 through 83.31) shall be complied with from sunset to sunrise, and during such times no other lights shall be exhibited, except such lights as cannot be mistaken for the lights specified in these Rules or do not impair their visibility or distinctive character, or interfere with the keeping of a proper lookout."
        },
        {
          "id": "c",
          "text": "(c) The lights prescribed by these Rules shall, if carried, also be exhibited from sunrise to sunset in restricted visibility and may be exhibited in all other circumstances when it is deemed necessary."
        },
        {
          "id": "d",
          "text": "(d) The Rules concerning shapes shall be complied with by day."
        },
        {
          "id": "e",
          "text": "(e) The lights and shapes specified in these Rules shall comply with the provisions of Annex I of these Rules (33 CFR part 84)."
        },
        {
          "id": "f",
          "text": "(f) A vessel's navigation lights and shapes may be lowered if necessary to pass under a bridge."
        }
      ]
    },
    "83.21": {
      "rule": 21,
      "heading": "Definitions (Rule 21).",
      "paragraphs": [
        {
          "id": "a",
          "text": "(a) Masthead light means a white light placed over the fore and aft centerline of the vessel showing an unbroken light over an arc of the horizon of 225 degrees and so fixed as to show the light from right ahead to 22.5 degrees abaft the beam on either side of the vessel, except that on a vessel of less than 12 meters in length the masthead light shall be placed as nearly as practicable to the fore and aft centerline of the vessel."
        },
        {
          "id": "b",
          "text": "(b) Sidelights mean a green light on the starboard side and a red light on the port side each showing an unbroken light over an arc of the horizon of 112.5 degrees and so fixed as to show the light from right ahead to 22.5 degrees abaft the beam on its respective side. On a vessel of less than 20 meters in length the side lights may be combined in one lantern carried on the fore and aft centerline of the vessel, except that on a vessel of less than 12 meters in length the sidelights when combined in one lantern shall be placed as nearly as practicable to the fore and aft centerline of the vessel."
        },
        {
          "id": "c",
          "text": "(c) Sternlight means a white light placed as nearly as practicable at the stern showing an unbroken light over an arc of the horizon of 135 degrees and so fixed as to show the light 67.5 degrees from right aft on each side of the vessel."
        },
        {
          "id": "d",
          "text": "(d) Towing light means a yellow light having the same characteristics as the “sternlight” defined in paragraph (c) of this Rule."
        },
        {
          "id": "e",
          "text": "(e) All-round light means a light showing an unbroken light over an arc of the horizon of 360 degrees."
        },
        {
          "id": "f",
          "text": "(f) Flashing light means a light flashing at regular intervals at a frequency of 120 flashes or more per minute."
        },
        {
          "id": "g",
          "text": "(g) Special flashing light means a yellow light flashing at regular intervals at a frequency of 50 to 70 flashes per minute, placed as far forward and as nearly as practicable on the fore and aft centerline of the tow and showing an unbroken light over an arc of the horizon of not less than 180 degrees nor more than 225 degrees and so fixed as to show the light from right ahead to abeam and no more than 22.5 degrees abaft the beam on either side of the vessel."
        }
      ]
    },
    "83.22": {
      "rule": 22,
      "heading": "Visibility of lights (Rule 22).",
      "paragraphs": [
        {
          "id": "intro",
          "text": "The lights prescribed in these Rules (Subpart C) shall have an intensity as specified in Annex I to these Rules (33 CFR part 84), so as to be visible at the following minimum ranges:"
        },
        {
          "id": "a",
          "text": "(a) In a vessel of 50 meters or more in length:"
        },
        {
          "id": "a(i)",
          "text": "(i) A masthead light, 6 miles;"
        },
        {
          "id": "a(ii)",
          "text": "(ii) A sidelight, 3 miles;"
        },
        {
          "id": "a(iii)",
          "text": "(iii) A sternlight, 3 miles;"
        },
        {
          "id": "a(iv)",
          "text": "(iv) A towing light, 3 miles;"
        },
        {
          "id": "a(v)",
          "text": "(v) A white, red, green or yellow all-round light, 3 miles; and"
        },
        {
          "id": "a(vi)",
          "text": "(vi) A special flashing light, 2 miles."
        },
        {
          "id": "b",
          "text": "(b) In a vessel of 12 meters or more in length but less than 50 meters in length:"
        },
        {
          "id": "b(i)",
          "text": "(i) A masthead light, 5 miles; except that where the length of the vessel is less than 20 meters, 3 miles;"
        },
        {
          "id": "b(ii)",
          "text": "(ii) A sidelight, 2 miles;"
        },
        {
          "id": "b(iii)",
          "text": "(iii) A sternlight, 2 miles;"
        },
        {
          "id": "b(iv)",
          "text": "(iv) A towing light, 2 miles;"
        },
        {
          "id": "b(v)",
          "text": "(v) A white, red, green or yellow all-round light, 2 miles; and"
        },
        {
          "id": "b(vi)",
          "text": "(vi) A special flashing light, 2 miles."
        },
        {
          "id": "c",
          "text": "(c) In a vessel of less than 12 meters in length:"
        },
        {
          "id": "c(i)",
          "text": "(i) A masthead light, 2 miles;"
        },
        {
          "id": "c(ii)",
          "text": "(ii) A sidelight, 1 mile;"
        },
        {
          "id": "c(iii)",
          "text": "(iii) A sternlight, 2 miles;"
        },
        {
          "id": "c(iv)",
          "text": "(iv) A towing light, 2 miles;"
        },
        {
          "id": "c(v)",
          "text": "(v) A white, red, green or yellow all-round light, 2 miles; and"
        },
        {
          "id": "c(vi)",
          "text": "(vi) A special flashing light, 2 miles."
        },
        {
          "id": "d",
          "text": "(d) In an inconspicuous, partly submerged vessel or objects being towed:"
        },
        {
          "id": "d(i)",
          "text": "(i) A white all-round light, 3 miles."
        },
        {
          "id": "d(ii)",
          "text": "(ii) [Reserved]"
        }
      ]
    },
    "83.23": {
      "rule": 23,
      "heading": "Power-driven vessels underway (Rule 23).",
      "paragraphs": [
        {
          "id": "a",
          "text": "(a) A power-driven vessel underway shall exhibit:"
        },
        {
          "id": "a(i)",
          "text": "(i) A masthead light forward;"
        },
        {
          "id": "a(ii)",
          "text": "(ii) A second masthead light abaft of and higher than the forward one; except that a vessel of less than 50 meters in length shall not be obliged to exhibit such light but may do so;"
        },
        {
          "id": "a(iii)",
          "text": "(iii) Sidelights; and"
        },
        {
          "id": "a(iv)",
          "text": "(iv) A sternlight."
        },
        {
          "id": "b",
          "text": "(b) An air-cushion vessel when operating in the non-displacement mode shall, in addition to the lights prescribed in paragraph (a) of this Rule, exhibit an all-round flashing yellow light where it can best be seen."
        },
        {
          "id": "c",
          "text": "(c) A WIG craft only when taking off, landing and in flight near the surface shall, in addition to the lights prescribed in paragraph (a) of this Rule, exhibit a high intensity all-round flashing red light."
        },
        {
          "id": "d",
          "text": "(d) A power-driven vessel of less than 12 meters in length may, in lieu of the lights prescribed in paragraph (a) of this Rule, exhibit an all-round white light and sidelights."
        },
        {
          "id": "e",
          "text": "(e) A power-driven vessel when operating on the Great Lakes may carry an all-round white light in lieu of the second masthead light and sternlight prescribed in paragraph (a) of this Rule. The light shall be carried in the position of the second masthead light and be visible at the same minimum range."
        }
      ]
    },
    "83.24": {
      "rule": 24,
      "heading": "Towing and pushing (Rule 24).",
      "paragraphs": [
        {
          "id": "a",
          "text": "(a) A power-driven vessel when towing astern shall exhibit:"
        },
        {
          "id": "a(i)",
          "text": "(i) Instead of the light prescribed either in Rule 23(a)(i) or 23(a)(ii) (§§ 83.23(a)(i) and (ii)), two masthead lights in a vertical line. When the length of the tow, measuring from the stern of the towing vessel to the after end of the tow exceeds 200 meters, three such lights in a vertical line;"
        },
        {
          "id": "a(ii)",
          "text": "(ii) Sidelights;"
        },
        {
          "id": "a(iii)",
          "text": "(iii) A sternlight;"
        },
        {
          "id": "a(iv)",
          "text": "(iv) A towing light in a vertical line above the sternlight; and"
        },
        {
          "id": "a(v)",
          "text": "(v) When the length of the tow exceeds 200 meters, a diamond shape where it can best be seen."
        },
        {
          "id": "b",
          "text": "(b) When a pushing vessel and a vessel being pushed ahead are rigidly connected in a composite unit they shall be regarded as a power-driven vessel and exhibit the lights prescribed in Rule 23 (§ 83.23)."
        },
        {
          "id": "c",
          "text": "(c) A power-driven vessel when pushing ahead or towing alongside, except as required by paragraphs (b) and (i) of this Rule, shall exhibit:"
        },
        {
          "id": "c(i)",
          "text": "(i) Instead of the light prescribed either in Rule 23(a)(i) or 23(a)(ii) (§ 83.23(a)(i) or (ii)), two masthead lights in a vertical line;"
        },
        {
          "id": "c(ii)",
          "text": "(ii) Sidelights; and"
        },
        {
          "id": "c(iii)",
          "text": "(iii) Two towing lights in a vertical line."
        },
        {
          "id": "d",
          "text": "(d) A power-driven vessel to which paragraphs (a) or (c) of this Rule applies shall also comply with Rule 23(a) (i) and 23(a)(ii)(§ 83.23(a)(i) or (ii))."
        },
        {
          "id": "e",
          "text": "(e) A vessel or object other than those referred to in paragraph (g) of this Rule being towed shall exhibit:"
        },
        {
          "id": "e(i)",
          "text": "(i) Sidelights;"
        },
        {
          "id": "e(ii)",
          "text": "(ii) A sternlight; and"
        },
        {
          "id": "e(iii)",
          "text": "(iii) When the length of the tow exceeds 200 meters, a diamond shape where it can best be seen."
        },
        {
          "id": "f",
          "text": "(f) Provided that any number of vessels being towed alongside or pushed in a group shall be lighted as one vessel, except as provided in paragraph (f)(iii) of this Rule."
        },
        {
          "id": "f(i)",
          "text": "(i) A vessel being pushed ahead, not being part of a composite unit, shall exhibit at the forward end, sidelights and a special flashing light."
        },
        {
          "id": "f(ii)",
          "text": "(ii) A vessel being towed alongside shall exhibit a sternlight and at the forward end, sidelights and a special flashing light."
        },
        {
          "id": "f(iii)",
          "text": "(iii) When vessels are towed alongside on both sides of the towing vessel, a sternlight shall be exhibited on the stern of the outboard vessel on each side of the towing vessel, and a single set of sidelights as far forward and as far outboard as is practicable, and a single special flashing light."
        },
        {
          "id": "g",
          "text": "(g) An inconspicuous, partly submerged vessel or object, or combination of such vessels or objects being towed, shall exhibit:"
        },
        {
          "id": "g(i)",
          "text": "(i) If it is less than 25 meters in breadth, one all-round white light at or near each end;"
        },
        {
          "id": "g(ii)",
          "text": "(ii) If it is 25 meters or more in breadth, four all-round white lights to mark its length and breadth;"
        },
        {
          "id": "g(iii)",
          "text": "(iii) If it exceeds 100 meters in length, additional all-round white lights between the lights prescribed in paragraphs (g)(i) and (ii) of this Rule so that the distance between the lights shall not exceed 100 meters: provided, that any vessels or objects being towed alongside each other shall be lighted as one vessel or object;"
        },
        {
          "id": "g(iv)",
          "text": "(iv) A diamond shape at or near the aftermost extremity of the last vessel or object being towed; and"
        },
        {
          "id": "g(v)",
          "text": "(v) The towing vessel may direct a searchlight in the direction of the tow to indicate its presence to an approaching vessel."
        },
        {
          "id": "h",
          "text": "(h) Where from any sufficient cause it is impracticable for a vessel or object being towed to exhibit the lights or shapes prescribed in paragraph (e) or (g) of this Rule, all possible measures shall be taken to light the vessel or object towed or at least to indicate the presence of such vessel or object."
        },
        {
          "id": "h(i)",
          "text": "(i) Where from any sufficient cause it is impracticable for a vessel not normally engaged in towing operations to display the lights prescribed by paragraph (a), (c), or (j) of this Rule, such vessel shall not be required to exhibit those lights when engaged in towing another vessel in distress or otherwise in need of assistance. All possible measures shall be taken to indicate the nature of the relationship between the towing vessel and the vessel being assisted. The searchlight authorized by Rule 36 (§ 83.36) may be used to illuminate the tow."
        },
        {
          "id": "j",
          "text": "(j) Notwithstanding paragraph (c) of this Rule, on the Western Rivers (except below the Huey P. Long Bridge at mile 106.1 Above Head of Passes on the Mississippi River) and on waters specified by the Secretary, a power-driven vessel when pushing ahead or towing alongside, except as paragraph (b) of this Rule applies, shall exhibit:"
        },
        {
          "id": "j(i)",
          "text": "(i) Sidelights; and"
        },
        {
          "id": "j(ii)",
          "text": "(ii) Two towing lights in a vertical line."
        }
      ]
    },
    "83.25": {
      "rule": 25,
      "heading": "Sailing vessels underway and vessels under oars (Rule 25).",
      "paragraphs": [
        {
          "id": "a",
          "text": "(a) A sailing vessel underway shall exhibit:"
        },
        {
          "id": "a(i)",
          "text": "(i) Sidelights; and"
        },
        {
          "id": "a(ii)",
          "text": "(ii) A sternlight."
        },
        {
          "id": "b",
          "text": "(b) In a sailing vessel of less than 20 meters in length the lights prescribed in paragraph (a) of this Rule may be combined in one lantern carried at or near the top of the mast where it can best be seen."
        },
        {
          "id": "c",
          "text": "(c) A sailing vessel underway may, in addition to the lights prescribed in paragraph (a) of this Rule, exhibit at or near the top of the mast, where they can best be seen, two all-round lights in a vertical line, the upper being red and the lower green, but these lights shall not be exhibited in conjunction with the combined lantern permitted by paragraph (b) of this Rule."
        },
        {
          "id": "d",
          "text": "(d)(i) A sailing vessel of less than 7 meters in length shall, if practicable, exhibit the lights prescribed in paragraph (a) or (b) of this Rule, but if she does not, she shall exhibit an all-round white light or have ready at hand an electric torch or lighted lantern showing a white light which shall be exhibited in sufficient time to prevent collision."
        },
        {
          "id": "d(ii)",
          "text": "(ii) A vessel under oars may exhibit the lights prescribed in this Rule for sailing vessels, but if she does not, she shall exhibit an all-round white light or have ready at hand an electric torch or lighted lantern showing a white light which shall be exhibited in sufficient time to prevent collision."
        },
        {
          "id": "e",
          "text": "(e) A vessel proceeding under sail when also being propelled by machinery shall exhibit forward, where it can best be seen, a conical shape, apex downward. A vessel of less than 12 meters in length is not required to exhibit this shape, but may do so."
        }
      ]
    },
    "83.26": {
      "rule": 26,
      "heading": "Fishing vessels (Rule 26).",
      "paragraphs": [
        {
          "id": "a",
          "text": "(a) A vessel engaged in fishing, whether underway or at anchor, shall exhibit only the lights and shapes prescribed in this Rule."
        },
        {
          "id": "b",
          "text": "(b) A vessel when engaged in trawling, by which is meant the dragging through the water of a dredge net or other apparatus used as a fishing appliance, shall exhibit:"
        },
        {
          "id": "b(i)",
          "text": "(i) Two all-round lights in a vertical line, the upper being green and the lower white, or a shape consisting of two cones with their apexes together in a vertical line one above the other;"
        },
        {
          "id": "b(ii)",
          "text": "(ii) A masthead light abaft of and higher than the all-round green light; a vessel of less than 50 meters in length shall not be obliged to exhibit such a light but may do so;"
        },
        {
          "id": "b(iii)",
          "text": "(iii) When making way through the water, in addition to the lights prescribed in this paragraph, sidelights and a sternlight."
        },
        {
          "id": "c",
          "text": "(c) A vessel engaged in fishing, other than trawling, shall exhibit:"
        },
        {
          "id": "c(i)",
          "text": "(i) Two all-round lights in a vertical line, the upper being red and the lower white, or a shape consisting of two cones with apexes together in a vertical line one above the other;"
        },
        {
          "id": "c(ii)",
          "text": "(ii) When there is outlying gear extending more than 150 meters horizontally from the vessel, an all-round white light or a cone apex upward in the direction of the gear;"
        },
        {
          "id": "c(iii)",
          "text": "(iii) When making way through the water, in addition to the lights prescribed in this paragraph, sidelights and a sternlight."
        },
        {
          "id": "d",
          "text": "(d) [Reserved]"
        },
        {
          "id": "e",
          "text": "(e) A vessel when not engaged in fishing shall not exhibit the lights or shapes prescribed in this Rule, but only those prescribed for a vessel of her length."
        },
        {
          "id": "f",
          "text": "(f) Additional signals for fishing vessels fishing in close proximity:"
        },
        {
          "id": "f(i)",
          "text": "(i) The lights mentioned herein shall be placed where they can best be seen. They shall be at least 0.9 meters apart but at a lower level than lights prescribed in this Rule. The lights shall be visible all round the horizon at a distance of at least 1 mile but at a lesser distance from the lights prescribed by paragraphs (a) through (c) of this Rule for fishing vessels."
        },
        {
          "id": "f(ii)",
          "text": "(ii) Signals for trawlers."
        },
        {
          "id": "f(ii)(1)",
          "text": "(1) Vessels when engaged in trawling, whether using demersal or pelagic gear, may exhibit:"
        },
        {
          "id": "f.cont1",
          "text": "(A) When shooting their nets: Two white lights in a vertical line;"
        },
        {
          "id": "f.cont2",
          "text": "(B) When hauling their nets: One white light over one red light in a vertical line;"
        },
        {
          "id": "f.cont3",
          "text": "(C) When a net has come fast upon an obstruction: Two red lights in a vertical line."
        },
        {
          "id": "f(ii)(2)",
          "text": "(2) Each vessel engaged in pair trawling may exhibit:"
        },
        {
          "id": "f.cont4",
          "text": "(A) By night, a searchlight directed forward and in the direction of the other vessel of the pair;"
        },
        {
          "id": "f.cont5",
          "text": "(B) When shooting or hauling their nets or when their nets have come fast upon an obstruction, the lights prescribed in paragraph (f)(ii)(1) of this Rule."
        },
        {
          "id": "f(iii)",
          "text": "(iii) Signals for purse seiners."
        },
        {
          "id": "f(iii)(1)",
          "text": "(1) Vessels engaged in fishing with purse seine gear may exhibit two yellow lights in a vertical line. These lights shall flash alternately every second and with equal light and occultation duration. These lights may be exhibited only when the vessel is hampered by its fishing gear."
        },
        {
          "id": "f(iii)(2)",
          "text": "(2) [Reserved]"
        }
      ]
    },
    "83.27": {
      "rule": 27,
      "heading": "Vessels not under command or restricted in their ability to maneuver (Rule 27).",
      "paragraphs": [
        {
          "id": "a",
          "text": "(a) A vessel not under command shall exhibit:"
        },
        {
          "id": "a(i)",
          "text": "(i) Two all-round red lights in a vertical line where they can best be seen;"
        },
        {
          "id": "a(ii)",
          "text": "(ii) Two balls or similar shapes in a vertical line where they can best be seen; and"
        },
        {
          "id": "a(iii)",
          "text": "(iii) When making way through the water, in addition to the lights prescribed in this paragraph, sidelights and a sternlight."
        },
        {
          "id": "b",
          "text": "(b) A vessel restricted in her ability to maneuver, except a vessel engaged in mine clearance operations, shall exhibit:"
        },
        {
          "id": "b(i)",
          "text": "(i) Three all-round lights in a vertical line where they can best be seen. The highest and lowest of these lights shall be red and the middle light shall be white;"
        },
        {
          "id": "b(ii)",
          "text": "(ii) Three shapes in a vertical line where they can best be seen. The highest and lowest of these shapes shall be balls and the middle one a diamond;"
        },
        {
          "id": "b(iii)",
          "text": "(iii) When making way through the water, a masthead light or lights, sidelights and a sternlight, in addition to the lights prescribed in paragraph (b)(i) of this Rule; and"
        },
        {
          "id": "b(iv)",
          "text": "(iv) When at anchor, in addition to the lights or shapes prescribed in paragraphs (b)(i) and (ii) of this Rule, the light, lights or shapes prescribed in Rule 30 (§ 83.30)."
        },
        {
          "id": "c",
          "text": "(c) A vessel engaged in a towing operation which severely restricts the towing vessel and her tow in their ability to deviate from their course shall, in addition to the lights or shapes prescribed in paragraphs (b)(i) and (ii) of this Rule, exhibit the lights or shapes prescribed in Rule 24 (§ 83.24)."
        },
        {
          "id": "d",
          "text": "(d) A vessel engaged in dredging or underwater operations, when restricted in her ability to maneuver, shall exhibit the lights and shapes prescribed in paragraphs (b)(i), (ii), and (iii) of this Rule and shall in addition, when an obstruction exists, exhibit:"
        },
        {
          "id": "d(i)",
          "text": "(i) Two all-round red lights or two balls in a vertical line to indicate the side on which the obstruction exists;"
        },
        {
          "id": "d(ii)",
          "text": "(ii) Two all-round green lights or two diamonds in a vertical line to indicate the side on which another vessel may pass; and"
        },
        {
          "id": "d(iii)",
          "text": "(iii) When at anchor, the lights or shapes prescribed by this paragraph, instead of the lights or shape prescribed in Rule 30 (§ 83.30)."
        },
        {
          "id": "d(iv)",
          "text": "(iv) Dredge pipelines that are floating or supported on trestles shall display the following lights at night and in periods of restricted visibility."
        },
        {
          "id": "d(iv)(1)",
          "text": "(1) One row of yellow lights. The lights must be:"
        },
        {
          "id": "d.cont1",
          "text": "(A) Flashing 50 to 70 times per minute,"
        },
        {
          "id": "d.cont2",
          "text": "(B) Visible all round the horizon,"
        },
        {
          "id": "d.cont3",
          "text": "(C) Visible for at least 2 miles,"
        },
        {
          "id": "d.cont4",
          "text": "(D) Not less than 1 and not more than 3.5 meters above the water,"
        },
        {
          "id": "d.cont5",
          "text": "(E) Approximately equally spaced, and"
        },
        {
          "id": "d.cont6",
          "text": "(F) Not more than 10 meters apart where the pipeline crosses a navigable channel. Where the pipeline does not cross a navigable channel the lights must be sufficient in number to clearly show the pipeline's length and course."
        },
        {
          "id": "d(iv)(2)",
          "text": "(2) Two red lights at each end of the pipeline, including the ends in a channel where the pipeline is separated to allow vessels to pass (whether open or closed). The lights must be:"
        },
        {
          "id": "d.cont7",
          "text": "(A) Visible all round the horizon, and"
        },
        {
          "id": "d.cont8",
          "text": "(B) Visible for at least 2 miles, and"
        },
        {
          "id": "d.cont9",
          "text": "(C) One meter apart in a vertical line with the lower light at the same height above the water as the flashing yellow light."
        },
        {
          "id": "e",
          "text": "(e) Whenever the size of a vessel engaged in diving operations makes it impracticable to exhibit all lights and shapes prescribed in paragraph (d) of this Rule, as appropriate, the following shall instead be exhibited:"
        },
        {
          "id": "e(i)",
          "text": "(i) Three all-round lights in a vertical line where they can best be seen. The highest and lowest of these lights shall be red and the middle light shall be white;"
        },
        {
          "id": "e(ii)",
          "text": "(ii) A rigid replica of the International Code flag “A” not less than 1 meter in height. Measures shall be taken to ensure its all-round visibility."
        },
        {
          "id": "f",
          "text": "(f) A vessel engaged in mine clearance operations shall, in addition to the lights prescribed for a power-driven vessel in Rule 23 (§ 83.23) or to the lights or shape prescribed for a vessel at anchor in Rule 30 (§ 83.30), as appropriate, exhibit three all-round green lights or three balls. One of these lights or shapes shall be exhibited near the foremast head and one at each end of the fore yard. These lights or shapes indicate that it is dangerous for another vessel to approach within 1000 meters of the mine clearance vessel."
        },
        {
          "id": "g",
          "text": "(g) A vessel of less than 12 meters in length, except when engaged in diving operations, is not required to exhibit the lights or shapes prescribed in this Rule."
        },
        {
          "id": "h",
          "text": "(h) The signals prescribed in this Rule are not signals of vessels in distress and requiring assistance. Such signals are contained in Annex IV to these Rules (33 CFR part 87)."
        }
      ]
    },
    "83.28": {
      "rule": 28,
      "heading": "[Reserved] (Rule 28).",
      "paragraphs": []
    },
    "83.29": {
      "rule": 29,
      "heading": "Pilot vessels (Rule 29).",
      "paragraphs": [
        {
          "id": "a",
          "text": "(a) A vessel engaged on pilotage duty shall exhibit:"
        },
        {
          "id": "a(i)",
          "text": "(i) At or near the masthead, two all-round lights in a vertical line, the upper being white and the lower red;"
        },
        {
          "id": "a(ii)",
          "text": "(ii) When underway, in addition, sidelights and a sternlight; and"
        },
        {
          "id": "a(iii)",
          "text": "(iii) When at anchor, in addition to the lights prescribed in paragraph (i) of this Rule, the anchor light, lights, or shape prescribed in Rule 30 (§ 83.30) for vessels at anchor."
        },
        {
          "id": "b",
          "text": "(b) A pilot vessel when not engaged on pilotage duty shall exhibit the lights or shapes prescribed for a vessel of her length."
        }
      ]
    },
    "83.30": {
      "rule": 30,
      "heading": "Vessels anchored, aground and moored barges (Rule 30).",
      "paragraphs": [
        {
          "id": "a",
          "text": "(a) A vessel at anchor shall exhibit where it can best be seen:"
        },
        {
          "id": "a(i)",
          "text": "(i) In the fore part, an all-round white light or one ball;"
        },
        {
          "id": "a(ii)",
          "text": "(ii) At or near the stern and at a lower level than the light prescribed in paragraph (i) of this Rule, an all-round white light."
        },
        {
          "id": "b",
          "text": "(b) A vessel of less than 50 meters in length may exhibit an all-round white light where it can best be seen instead of the lights prescribed in paragraph (a) of this Rule."
        },
        {
          "id": "c",
          "text": "(c) A vessel at anchor may, and a vessel of 100 meters or more in length shall, also use the available working or equivalent lights to illuminate her decks."
        },
        {
          "id": "d",
          "text": "(d) A vessel aground shall exhibit the lights prescribed in paragraph (a) or (b) of this Rule and in addition, if practicable, where they can best be seen:"
        },
        {
          "id": "d(i)",
          "text": "(i) Two all-round red lights in a vertical line; and"
        },
        {
          "id": "d(ii)",
          "text": "(ii) Three balls in a vertical line."
        },
        {
          "id": "e",
          "text": "(e) A vessel of less than 7 meters in length, when at anchor, not in or near a narrow channel, fairway, anchorage, or where other vessels normally navigate, shall not be required to exhibit the lights or shape prescribed in paragraphs (a) and (b) of this Rule."
        },
        {
          "id": "f",
          "text": "(f) A vessel of less than 12 meters in length when aground shall not be required to exhibit the lights or shapes prescribed in paragraphs (d)(i) and (ii) of this Rule."
        },
        {
          "id": "g",
          "text": "(g) A vessel of less than 20 meters in length, when at anchor in a special anchorage area designated by the Coast Guard, shall not be required to exhibit the anchor lights and shapes required by this Rule."
        },
        {
          "id": "h",
          "text": "(h) The following barges shall display at night and if practicable in periods of restricted visibility the lights described in paragraph (i) of this Rule:"
        },
        {
          "id": "h(i)",
          "text": "(i) Every barge projecting into a buoyed or restricted channel."
        },
        {
          "id": "h(ii)",
          "text": "(ii) Every barge so moored that it reduces the available navigable width of any channel to less than 80 meters."
        },
        {
          "id": "h(iii)",
          "text": "(iii) Barges moored in groups more than two barges wide or to a maximum width of over 25 meters."
        },
        {
          "id": "h(iv)",
          "text": "(iv) Every barge not moored parallel to the bank or dock."
        },
        {
          "id": "i",
          "text": "(i) Barges described in paragraph (h) of this Rule shall carry two unobstructed all-round white lights of an intensity to be visible for at least 1 nautical mile and meeting the technical requirements as prescribed in Annex I (33 CFR part 84)."
        },
        {
          "id": "j",
          "text": "(j) A barge or group of barges at anchor or made fast to one or more mooring buoys or other similar device, in lieu of the provisions of this Rule, may carry unobstructed all-round white lights of an intensity to be visible for at least 1 nautical mile that meet the requirements of Annex I (33 CFR part 84) and shall be arranged as follows:"
        },
        {
          "id": "j(i)",
          "text": "(i) Any barge that projects from a group formation, shall be lighted on its outboard corners."
        },
        {
          "id": "j(ii)",
          "text": "(ii) On a single barge moored in water where other vessels normally navigate on both sides of the barge, lights shall be placed to mark the corner extremities of the barge."
        },
        {
          "id": "j(iii)",
          "text": "(iii) On barges moored in group formation, moored in water where other vessels normally navigate on both sides of the group, lights shall be placed to mark the corner extremities of the group."
        },
        {
          "id": "k",
          "text": "(k) The following are exempt from the requirements of this Rule:"
        },
        {
          "id": "k(i)",
          "text": "(i) A barge or group of barges moored in a slip or slough used primarily for mooring purposes."
        },
        {
          "id": "k(ii)",
          "text": "(ii) A barge or group of barges moored behind a pierhead."
        },
        {
          "id": "k(iii)",
          "text": "(iii) A barge less than 20 meters in length when moored in a special anchorage area designated in accordance with § 109.10 of this chapter."
        },
        {
          "id": "l",
          "text": "(l) Barges moored in well-illuminated areas are exempt from the lighting requirements of this Rule. These areas are as follows:"
        }
      ]
    },
    "83.31": {
      "rule": 31,
      "heading": "Seaplanes (Rule 31).",
      "paragraphs": [
        {
          "id": "intro",
          "text": "Where it is impracticable for a seaplane or a WIG craft to exhibit lights and shapes of the characteristics or in the positions prescribed in the Rules of this subpart, she shall exhibit lights and shapes as closely similar in characteristics and position as is possible."
        }
      ]
    },
    "83.32": {
      "rule": 32,
      "heading": "Definitions (Rule 32).",
      "paragraphs": [
        {
          "id": "a",
          "text": "(a) The word whistle means any sound signaling appliance capable of producing the prescribed blasts and which complies with specifications in Annex III to these Rules (33 CFR part 86)."
        },
        {
          "id": "b",
          "text": "(b) The term short blast means a blast of about 1 second's duration."
        },
        {
          "id": "c",
          "text": "(c) The term prolonged blast means a blast of from 4 to 6 seconds' duration."
        }
      ]
    },
    "83.33": {
      "rule": 33,
      "heading": "Equipment for sound signals (Rule 33).",
      "paragraphs": [
        {
          "id": "a",
          "text": "(a) A vessel of 12 meters or more in length shall be provided with a whistle, a vessel of 20 meters or more in length shall be provided with a bell in addition to a whistle, and a vessel of 100 meters or more in length shall, in addition, be provided with a gong, the tone and sound of which cannot be confused with that of the bell. The whistle, bell and gong shall comply with the specifications in Annex III to these Rules (33 CFR part 86). The bell or gong or both may be replaced by other equipment having the same respective sound characteristics, provided that manual sounding of the prescribed signals shall always be possible."
        },
        {
          "id": "b",
          "text": "(b) A vessel of less than 12 meters in length shall not be obliged to carry the sound signaling appliances prescribed in paragraph (a) of this Rule but if she does not, she shall be provided with some other means of making an efficient sound signal."
        }
      ]
    },
    "83.34": {
      "rule": 34,
      "heading": "Maneuvering and warning signals (Rule 34).",
      "paragraphs": [
        {
          "id": "a",
          "text": "(a) When power-driven vessels are in sight of one another and meeting or crossing at a distance within half a mile of each other, each vessel underway, when maneuvering as authorized or required by these Rules:"
        },
        {
          "id": "a(i)",
          "text": "(i) Shall indicate that maneuver by the following signals on her whistle:"
        },
        {
          "id": "a(i)(1)",
          "text": "(1) One short blast to mean “I intend to leave you on my port side”;"
        },
        {
          "id": "a(i)(2)",
          "text": "(2) Two short blasts to mean “I intend to leave you on my starboard side”; and"
        },
        {
          "id": "a(i)(3)",
          "text": "(3) Three short blasts to mean “I am operating astern propulsion”."
        },
        {
          "id": "a(ii)",
          "text": "(ii) Upon hearing the one or two blast signal of the other shall, if in agreement, sound the same whistle signal and take the steps necessary to effect a safe passing. If, however, from any cause, the vessel doubts the safety of the proposed maneuver, she shall sound the signal specified in paragraph (d) of this Rule and each vessel shall take appropriate precautionary action until a safe passing agreement is made."
        },
        {
          "id": "b",
          "text": "(b) A vessel may supplement the whistle signals prescribed in paragraph (a) of this Rule by light signals:"
        },
        {
          "id": "b(i)",
          "text": "(i) These signals shall have the following significance:"
        },
        {
          "id": "b(i)(1)",
          "text": "(1) One flash to mean “I intend to leave you on my port side”;"
        },
        {
          "id": "b(i)(2)",
          "text": "(2) Two flashes to mean “I intend to leave you on my starboard side”;"
        },
        {
          "id": "b(i)(3)",
          "text": "(3) Three flashes to mean “I am operating astern propulsion”;"
        },
        {
          "id": "b(ii)",
          "text": "(ii) The duration of each flash shall be about 1 second; and"
        },
        {
          "id": "b(iii)",
          "text": "(iii) The light used for this signal shall, if fitted, be one all-round white or yellow light, visible at a minimum range of 2 miles, synchronized with the whistle, and shall comply with the provisions of Annex I to these Rules (33 CFR part 84)."
        },
        {
          "id": "c",
          "text": "(c) When in sight of one another:"
        },
        {
          "id": "c(i)",
          "text": "(i) A power-driven vessel intending to overtake another power-driven vessel shall indicate her intention by the following signals on her whistle:"
        },
        {
          "id": "c(i)(1)",
          "text": "(1) One short blast to mean “I intend to overtake you on your starboard side”;"
        },
        {
          "id": "c(i)(2)",
          "text": "(2) Two short blasts to mean “I intend to overtake you on your port side”; and"
        },
        {
          "id": "c(ii)",
          "text": "(ii) The power-driven vessel about to be overtaken shall, if in agreement, sound a similar sound signal. If in doubt she shall sound the signal prescribed in paragraph (d) of this Rule."
        },
        {
          "id": "d",
          "text": "(d) When vessels in sight of one another are approaching each other and, from any cause, either vessel fails to understand the intentions or actions of the other, or is in doubt whether sufficient action is being taken by the other to avoid collision, the vessel in doubt shall immediately indicate such doubt by giving at least five short and rapid blasts on the whistle. Such signal may be supplemented by a light signal of at least five short and rapid flashes."
        },
        {
          "id": "e",
          "text": "(e) A vessel nearing a bend or an area of a channel or fairway where other vessels may be obscured by an intervening obstruction shall sound one prolonged blast. This signal shall be answered with a prolonged blast by any approaching vessel that may be within hearing around the bend or behind the intervening obstruction."
        },
        {
          "id": "f",
          "text": "(f) If whistles are fitted on a vessel at a distance apart of more than 100 meters, one whistle only shall be used for giving maneuvering and warning signals."
        },
        {
          "id": "g",
          "text": "(g) When a power-driven vessel is leaving a dock or berth, she shall sound one prolonged blast."
        },
        {
          "id": "h",
          "text": "(h) A vessel that reaches agreement with another vessel in a head-on, crossing, or overtaking situation, as for example, by using the radiotelephone as prescribed by the Vessel Bridge-to-Bridge Radiotelephone Act (85 Stat. 164; 33 U.S.C. 1201 et seq.), is not obliged to sound the whistle signals prescribed by this Rule, but may do so. If agreement is not reached, then whistle signals shall be exchanged in a timely manner and shall prevail."
        }
      ]
    },
    "83.35": {
      "rule": 35,
      "heading": "Sound signals in restricted visibility (Rule 35).",
      "paragraphs": [
        {
          "id": "intro",
          "text": "In or near an area of restricted visibility, whether by day or night, the signals prescribed in this Rule shall be used as follows:"
        },
        {
          "id": "a",
          "text": "(a) A power-driven vessel making way through the water shall sound, at intervals of not more than 2 minutes, one prolonged blast."
        },
        {
          "id": "b",
          "text": "(b) A power-driven vessel underway but stopped and making no way through the water shall sound, at intervals of not more than 2 minutes, two prolonged blasts in succession, with an interval of about 2 seconds between them."
        },
        {
          "id": "c",
          "text": "(c) A vessel not under command; a vessel restricted in her ability to maneuver, whether underway or at anchor; a sailing vessel; a vessel engaged in fishing, whether underway or at anchor; and a vessel engaged in towing or pushing another vessel shall, instead of the signals prescribed in paragraphs (a) or (b) of this Rule, sound, at intervals of not more than 2 minutes, three blasts in succession, namely, one prolonged followed by two short blasts."
        },
        {
          "id": "d",
          "text": "(d) [Reserved]"
        },
        {
          "id": "e",
          "text": "(e) A vessel towed or if more than one vessel is towed the last vessel of the tow, if manned, shall at intervals of not more than 2 minutes sound four blasts in succession, namely, one prolonged followed by three short blasts. When practicable, this signal shall be made immediately after the signal made by the towing vessel."
        },
        {
          "id": "f",
          "text": "(f) When a pushing vessel and a vessel being pushed ahead are rigidly connected in a composite unit they shall be regarded as a power-driven vessel and shall give the signals prescribed in paragraphs (a) or (b) of this Rule."
        },
        {
          "id": "g",
          "text": "(g) A vessel at anchor shall at intervals of not more than 1 minute ring the bell rapidly for about 5 seconds. In a vessel of 100 meters or more in length the bell shall be sounded in the forepart of the vessel and immediately after the ringing of the bell the gong shall be sounded rapidly for about 5 seconds in the after part of the vessel. A vessel at anchor may in addition sound three blasts in succession, namely, one short, one prolonged and one short blast, to give warning of her position and of the possibility of collision to an approaching vessel."
        },
        {
          "id": "h",
          "text": "(h) A vessel aground shall give the bell signal and if required the gong signal prescribed in paragraph (g) of this Rule and shall, in addition, give three separate and distinct strokes on the bell immediately before and after the rapid ringing of the bell. A vessel aground may in addition sound an appropriate whistle signal."
        },
        {
          "id": "h(i)",
          "text": "(i) A vessel of 12 meters or more but less than 20 meters in length shall not be obliged to give the bell signals prescribed in paragraphs (g) and (h) of this Rule. However, if she does not, she shall make some other efficient sound signal at intervals of not more than 2 minutes."
        },
        {
          "id": "j",
          "text": "(j) A vessel of less than 12 meters in length shall not be obliged to give the above-mentioned signals but, if she does not, shall make some other efficient sound signal at intervals of not more than 2 minutes."
        },
        {
          "id": "k",
          "text": "(k) A pilot vessel when engaged on pilotage duty may, in addition to the signals prescribed in paragraphs (a), (b) or (g) of this Rule, sound an identity signal consisting of four short blasts."
        },
        {
          "id": "l",
          "text": "(l) The following vessels shall not be required to sound signals as prescribed in paragraph (g) of this Rule when anchored in a special anchorage area designated by the Coast Guard:"
        },
        {
          "id": "l(i)",
          "text": "(i) A vessel of less than 20 meters in length; and"
        },
        {
          "id": "l(ii)",
          "text": "(ii) A barge, canal boat, scow, or other nondescript craft."
        }
      ]
    },
    "83.36": {
      "rule": 36,
      "heading": "Signals to attract attention (Rule 36).",
      "paragraphs": [
        {
          "id": "intro",
          "text": "If necessary to attract the attention of another vessel, any vessel may make light or sound signals that cannot be mistaken for any signal authorized elsewhere in these Rules, or may direct the beam of her searchlight in the direction of the danger, in such a way as not to embarrass any vessel."
        }
      ]
    },
    "83.37": {
      "rule": 37,
      "heading": "Distress signals (Rule 37).",
      "paragraphs": [
        {
          "id": "intro",
          "text": "When a vessel is in distress and requires assistance she shall use or exhibit the signals described in Annex IV to these Rules (33 CFR part 87)."
        }
      ]
    },
    "83.38": {
      "rule": 38,
      "heading": "Exemptions (Rule 38).",
      "paragraphs": [
        {
          "id": "intro",
          "text": "Any vessel or class of vessels, the keel of which was laid or which was at a corresponding stage of construction before December 24, 1980, provided that she complies with the requirements of—"
        },
        {
          "id": "a",
          "text": "(a) The Act of June 7, 1897 (30 Stat. 96), as amended (33 U.S.C. 154-232) for vessels navigating the waters subject to that statute;"
        },
        {
          "id": "b",
          "text": "(b) Section 4233 of the Revised Statutes (33 U.S.C. 301-356) for vessels navigating the waters subject to that statute;"
        },
        {
          "id": "c",
          "text": "(c) The Act of February 8, 1895 (28 Stat. 645), as amended (33 U.S.C. 241-295) for vessels navigating the waters subject to that statute; or"
        },
        {
          "id": "d",
          "text": "(d) Sections 3, 4, and 5 of the Act of April 25, 1940 (54 Stat. 163), as amended (46 U.S.C. 526b, c, and d) for motorboats navigating the waters subject to that statute, shall be exempted from compliance with the technical Annexes to these Rules (33 CFR parts 84 through 88) as follows:"
        },
        {
          "id": "d(i)",
          "text": "(i) The installation of lights with ranges prescribed in Rule 22 (§ 83.22), vessels of less than 20 meters in length are permanently exempt."
        },
        {
          "id": "d(ii)",
          "text": "(ii) The installation of lights with color specifications as prescribed in Annex I to these Rules (33 CFR part 84), vessels of less than 20 meters in length are permanently exempt."
        },
        {
          "id": "d(iii)",
          "text": "(iii) The repositioning of lights as a result of conversion to metric units and rounding off measurement figures are permanently exempt."
        },
        {
          "id": "d(iv)",
          "text": "(iv) The horizontal repositioning of masthead lights prescribed by Annex I to these Rules (33 CFR part 84), vessels of less than 150 meters in length are permanently exempt; and"
        },
        {
          "id": "d(v)",
          "text": "(v) Power-driven vessels of 12 meters or more but less than 20 meters in length are permanently exempt from the provisions of Rule 23(a)(i) and (iv) (§ 83.23(a)(i) and (iv)) provided that, in place of these lights, the vessel exhibits a white light aft visible all-round the horizon."
        }
      ]
    }
  }
}
